import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Icon from '@projeccions-pdc/react-icon';
import IdentityService from '../../apiclients/IdentityService';
import { cloneDeep } from 'lodash';
import { withStyles } from '@material-ui/core';
import { Content, File, Image, Video } from './HomeResultsComponents';
import EnhancedGrid from '../Common/Grid/EnhancedGrid';
import LocalizedStrings from '../Localization/localization';
import SearchService from '../../apiclients/SearchService';
import TagService from '../../apiclients/TagService';
import NewSearch from '../Library/NewSearch';
import AppContext from '../../AppContext';

import { isSmartphone } from '../../helpers';
import './Search.css';

const ImageIcon = 'md-image';
const ContentIcon = 'md-reorder';
const CollectionIcon = 'md-add-to-photos';
const MeetingsIcon = 'md-today';
const VideoIcon = 'md-video-library';
const FileIcon = 'md-insert-drive-file';
const CategoryIcon = 'md-folder-open'; //md-folder
const MetadocumentIcon = 'fa-file-o'; //'md-insert-drive-file';
const ExternalLinkIcon = 'md-open-in-new';

let queryCounters = {
    tags: 0,
    author: 0,
};

//TODO: colors must come from props
const styles = {
    indicatorLight: {
        backgroundColor: '#fff',
    },
    indicatorDark: {
        backgroundColor: '#000',
    },
    scrollButtonsLight: {
        color: '#fff',
    },
    scrollButtonsDark: {
        color: '#000',
    },
    scrollable: {
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
            width: '0px' /* remove scrollbar space */,
            background: 'transparent' /* optional: just make scrollbar invisible */,
        },
    },
};

class Search extends Component {
    state = {
        searchValue: '',
        pendingQueryChanges: false,
        searchResults: [],
        searchLastKey: undefined,
        autocompleteResultsLliure: undefined,
        autocompleteResultsTags: undefined,
        autocompleteResultsAuthor: undefined,
        searchFilters: {},
        autocompleteOptionsOpen: false,
        loading: false,
        tab: 0,
        //editing: false,
    };

    componentDidMount() {
        // this.searchInterval = setInterval(() => {
        //     if (this.state.pendingQueryChanges) {
        //         this.search();
        //     }
        // }, 5000);

        isSmartphone((match) => this.handleSizeChange(match));
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.platformId !== this.props.platformId) {
        //     this.resetSearch();
        // }
    }

    componentWillUnmount() {
        // clearInterval(this.searchInterval);
    }

    handleOnFocus = (value) => {
        this.props.onEditingChange(true);
    };

    handleOnBlur = (value) => {
        this.props.onEditingChange(this.getSearchQuery() !== '' || this.state.searchValue !== '');
    };

    handleKeyPress = (evt) => {
        if (evt.key === 'Enter') {
            this.search();
        }
    };

    handleOnChange = (value, evt) => {
        this.autocomplete(value);
        this.setState({
            searchValue: value,
            pendingQueryChanges: true,
        });
    };

    autocomplete = async (query) => {
        this.setState({ loading: true });

        if (query !== '') {
            this.autocompleteLliure(query);
            await this.autocompleteTags(query);

            let appContext = new AppContext();
            let currentUserIsAdmin = appContext.getMyInfo().isAdmin;
            if (currentUserIsAdmin === true) {
                await this.autocompleteAuthor(query);
            }
            this.setState({ loading: false });
        } else {
            this.setState({
                autocompleteResultsTags: undefined,
                autocompleteResultsAuthor: undefined,
                autocompleteResultsLliure: undefined,
                loading: false,
            });
        }
    };

    autocompleteLliure = (query) => {
        let newAutocomplete = {};
        newAutocomplete.results = [{ title: query, label: query, value: query, type: 'text' }];
        newAutocomplete.name = 'text';
        this.setState({
            autocompleteResultsLliure: newAutocomplete,
            autocompleteOptionsOpen: true,
        });
    };

    autocompleteTags = (tagPrefix) => {
        let lastQueryId = ++queryCounters.tags;

        return TagService.getTags(tagPrefix)
            .then((data) => {
                if (lastQueryId !== queryCounters.tags) return;
                let newAutocomplete = cloneDeep(this.state.autocompleteResultsTags ? this.state.autocompleteResultsTags : {});
                newAutocomplete.results = data.items;
                newAutocomplete.results = newAutocomplete.results.map((tag) => {
                    return { title: tag, label: tag, value: tag, type: 'tags' };
                });

                newAutocomplete.name = 'tags';
                this.setState({
                    autocompleteResultsTags: newAutocomplete,
                    autocompleteOptionsOpen: true,
                });
            })
            .catch((err) => {
                if (lastQueryId !== queryCounters.tags) return;
                if (this.props.notify) {
                    this.props.notify('error', 'Error while autocompleting tags');
                }
                console.log(err);
            });
    };

    autocompleteAuthor = (authorPrefix) => {
        let lastQueryId = ++queryCounters.author;
        return IdentityService.searchUsers(authorPrefix)
            .then((data) => {
                if (lastQueryId !== queryCounters.author) return;
                let newAutocomplete = cloneDeep(this.state.autocompleteResultsAuthor ? this.state.autocompleteResultsAuthor : {});
                newAutocomplete.name = 'author';
                newAutocomplete.results = data.items;
                // console.log('author', newAutocomplete.results);
                newAutocomplete.results = newAutocomplete.results.map((author) => {
                    return { title: author.name, label: author.name, value: author.userSub, type: 'author' };
                });
                this.setState({
                    autocompleteResultsAuthor: newAutocomplete,
                    autocompleteOptionsOpen: true,
                });
            })
            .catch((err) => {
                if (lastQueryId !== queryCounters.author) return;
                if (this.props.notify) {
                    this.props.notify('error', 'Error while autocompleting author');
                }
                console.log(err);
            });
    };

    // applyFilter = element => {
    //     let newFilters = cloneDeep(this.state.searchFilters);
    //     newFilters.author = element;
    //     this.setState({ searchFilters: newFilters, autocompleteOptionsOpen: false }, () => this.search());
    // };

    // removeFilter = () => {
    //     let newFilters = cloneDeep(this.state.searchFilters);
    //     delete newFilters.author;
    //     this.setState({ searchFilters: newFilters }, () => this.search());
    // };

    // applyAutoComplete = element => {
    //     let newValue = this.simulateAutoComplete(element);
    //     this.setState({ searchValue: newValue, autocompleteOptionsOpen: false }, () => this.search());
    // };

    // simulateAutoComplete = element => {
    //     let aux = this.state.searchValue.split(' ');
    //     aux[aux.length - 1] = element;
    //     return aux.join(' ');
    // };

    // autocompleteOptionsClose = () => {
    //     if (this.state.autocompleteOptionsOpen !== false) {
    //         this.setState({ autocompleteOptionsOpen: false });
    //     }
    // };

    // onSearchFocus = () => {
    //     if (Object.keys(this.state.autocompleteResultsTags).length > 0 || Object.keys(this.state.autocompleteResultsAuthor).length > 0) {
    //         this.setState({ autocompleteOptionsOpen: true });
    //     }
    // };

    handleSelectedResult = (values) => {
        //console.log('handleSelectedResult', values);
        let newValues = cloneDeep({
            tags: { max: -1, values: [] },
            author: { max: 1, values: [] },
            text: { max: -1, values: [] },
        });
        for (let i = 0; i < values.length; i++) {
            let result = values[i];
            if (result) {
                if (newValues[result.type].max === -1 || newValues[result.type].values.length < newValues[result.type].max) {
                    if (newValues[result.type].values.indexOf(result) === -1) {
                        newValues[result.type].values.push(result);
                    }
                }
            }
        }
        this.setState({ activeFilters: newValues, searchValue: '' }, () => this.search());
    };

    search = (lastKey, loadMoreType) => {
        this.setState({ loading: true });

        let queries = [];
        if (!lastKey || loadMoreType === 'cm') {
            queries.push(this.searchResults('content', ['c', 'm'], lastKey));
        }
        if (!lastKey || loadMoreType === 'col') {
            queries.push(this.searchResults('content', 'col', lastKey));
        }
        if (!lastKey || loadMoreType === 'mtg') {
            queries.push(this.searchResults('content', 'mtg', lastKey));
        }
        if (!lastKey || loadMoreType === 'file') {
            queries.push(this.searchResults('file', 'file', lastKey));
        }
        if (!lastKey || loadMoreType === 'image') {
            queries.push(this.searchResults('file', 'image', lastKey));
        }
        if (!lastKey || loadMoreType === 'video') {
            queries.push(this.searchResults('file', 'video', lastKey));
        }

        Promise.all(queries).then((data) => {
            this.setState({ loading: false });
        });
    };

    loadMore = (typeId) => {
        this.search(this.state[`searchLastKey${typeId}`], typeId);
    };

    getSearchQuery = () => {
        let searchQuery = '';
        let activeFilters = this.state.activeFilters;
        if (!activeFilters) return searchQuery;
        let tags = activeFilters.tags ? activeFilters.tags.values : [];
        let texts = activeFilters.text ? activeFilters.text.values : [];

        tags.forEach((tag) => {
            searchQuery += `${tag.value} `;
        });
        texts.forEach((text) => {
            searchQuery += `${text.value} `;
        });

        return searchQuery;
    };

    searchResults = (resourceType, resourceSubtype, lastKey) => {
        let activeFilters = this.state.activeFilters;
        if (!activeFilters) return;
        let authors = activeFilters.author ? activeFilters.author.values : [];
        let author = authors.length > 0 ? authors[0].value : undefined;

        let searchQuery = this.getSearchQuery();

        if (searchQuery === '' && author === undefined) return;

        if (resourceType === 'file' && this.props.shareContext === true) {
            searchQuery += 'shareable_true ';
        }

        return SearchService.getSearchResults(searchQuery, author, resourceType, resourceSubtype, lastKey)
            .then((data) => {
                let rst = resourceSubtype;
                if (Array.isArray(rst)) {
                    rst = rst.join('');
                }

                let dataItems = [];
                if (lastKey) {
                    dataItems = this.state[`searchResults${rst}`];
                }
                if (data.results) {
                    dataItems = dataItems.concat(data.results);
                }

                this.setState({
                    [`searchResults${rst}`]: dataItems,
                    [`searchLastKey${rst}`]: data.lastKey,
                });
            })
            .catch((err) => {
                if (this.props.notify) {
                    this.props.notify('error', 'Error while searching ' + resourceType + ' ' + resourceSubtype);
                }
                console.log(err);
            });
    };

    // resetSearch = () => {
    //     this.setState({
    //         searchValue: '',
    //         pendingQueryChanges: false,
    //         searchResults: [],
    //         autocompleteResultsLliure: undefined,
    //         autocompleteResultsTags: undefined,
    //         autocompleteResultsAuthor: undefined,
    //         searchFilters: {},
    //         autocompleteOptionsOpen: false,
    //         loading: false,
    //         tab: 0
    //     });
    //     if (this.props.resetSearch) {
    //         this.props.resetSearch();
    //     }
    // };

    handleTabChange = (event, value) => {
        this.setState({ tab: value });
    };

    isLight = () => {
        if (this.props.searchStyle.field.color === 'black' || this.props.searchStyle.field.color === '#000') {
            return false;
        }
        return true;
    };

    renderResults = () => {
        const iconStyle = {
            color: this.props.searchStyle.field.color,
            size: '20px',
        };

        if (this.getSearchQuery() === '') {
            return '';
        }

        let resultTypes = [
            {
                id: 'cm',
                icon: ContentIcon,
                name: LocalizedStrings.contents,
                ResultsObject: Content,
                gridProps: {
                    cellHeight: 180,
                    cols: this.props.cols ? this.props.cols : this.state.smartphoneView ? 2 : 4,
                    spacing: 10,
                },
            },
            {
                id: 'col',
                icon: CollectionIcon,
                name: 'Collections',
                ResultsObject: Content,
                gridProps: {
                    cellHeight: 180,
                    cols: this.props.cols ? this.props.cols : this.state.smartphoneView ? 2 : 4,
                    spacing: 10,
                },
            },
            {
                id: 'mtg',
                icon: MeetingsIcon,
                name: 'Meetings',
                ResultsObject: Content,
                gridProps: {
                    cellHeight: 180,
                    cols: this.props.cols ? this.props.cols : this.state.smartphoneView ? 2 : 4,
                    spacing: 10,
                },
            },
            {
                id: 'image',
                icon: ImageIcon,
                name: LocalizedStrings.images,
                ResultsObject: Image,
                gridProps: {
                    cellHeight: 180,
                    cols: this.props.cols ? this.props.cols : this.state.smartphoneView ? 2 : 4,
                    spacing: 10,
                },
            },
            {
                id: 'video',
                icon: VideoIcon,
                name: LocalizedStrings.videos,
                ResultsObject: Video,
                gridProps: {
                    cellHeight: 180,
                    cols: this.props.cols ? this.props.cols : this.state.smartphoneView ? 2 : 4,
                    spacing: 10,
                },
            },
            {
                id: 'file',
                icon: FileIcon,
                name: LocalizedStrings.files,
                ResultsObject: File,
                gridProps: {
                    cellHeight: 280,
                    cols: this.props.cols ? this.props.cols : this.state.smartphoneView ? 2 : 4,
                    spacing: 10,
                },
                // gridProps: {
                //     cellHeight: 'auto',
                //     cols: 4,
                //     spacing: 10,
                // },
            },
        ];

        let tabs = [];
        let results = [];
        resultTypes.forEach((type) => {
            let gridData;
            gridData = this.state[`searchResults${type.id}`];
            if (gridData && gridData.length > 0) {
                // let TypeResults = type.ResultsObject;
                let canLoadMore = this.state[`searchLastKey${type.id}`] ? true : false;
                tabs.push(
                    <Tab
                        key={type.id}
                        style={{ color: this.props.searchStyle.field.color }}
                        label={
                            <div
                                style={{
                                    textTransform: 'capitalize',
                                    fontSize: '16px',
                                }}
                            >
                                <Icon name={type.icon} primaryColor={iconStyle.color} size={iconStyle.size} />
                                {`  ${type.name} (${gridData.length}${canLoadMore ? '+' : ''})`}
                            </div>
                        }
                    />
                );

                results.push(
                    <EnhancedGrid
                        gridTitle={''}
                        rowId={'resourceId'}
                        gridHeader={false}
                        gridProps={type.gridProps}
                        showContainer={false}
                        multipleChoice={false}
                        columnData={[]}
                        data={gridData}
                        loadMore={this.state[`searchLastKey${type.id}`] ? () => this.loadMore(type.id) : undefined}
                        actions={[]}
                        GridItemComponent={type.ResultsObject}
                        //     (props) => {
                        //     // return (
                        //     //     <TypeResults {...props} style={{ ...props.style, ...{ cursor: 'pointer' } }} />
                        //     // );

                        //     return (
                        //         React.createElement(type.ResultsObject, {
                        //             ...props,
                        //             style: { ...props.style, ...{ cursor: 'pointer' } },
                        //         })
                        //     );
                        // }}
                        onItemClick={this.props.onResultSelected}
                        embeded={this.props.embeded}
                    />
                );
            }
        });

        return (
            <div
                className={'Home-results'}
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-around',
                }}
            >
                {tabs && tabs.length > 0 ? (
                    <div style={{ width: '100%' }}>
                        <Tabs
                            value={this.state.tab}
                            onChange={this.handleTabChange}
                            variant="scrollable"
                            scrollButtons="on"
                            TabIndicatorProps={{
                                classes: {
                                    root: this.isLight() === true ? this.props.classes.indicatorLight : this.props.classes.indicatorDark,
                                },
                            }}
                            classes={{
                                scrollButtons:
                                    this.isLight() === true ? this.props.classes.scrollButtonsLight : this.props.classes.scrollButtonsDark,
                                scrollable: this.props.classes.scrollable,
                            }}
                        >
                            {tabs}
                        </Tabs>
                        {results[this.state.tab]}
                    </div>
                ) : (
                    <div
                        style={{
                            color: this.props.searchStyle.field.color,
                            marginTop: '20px',
                        }}
                    >
                        {LocalizedStrings.noResults}
                    </div>
                )}
            </div>
        );
    };

    render() {
        let style = {
            textAlign: 'center',
            display: 'inline-block',
            width: this.props.searchStyle.field.width,
            color: this.props.searchStyle.field.color,
        };

        return (
            <div style={this.props.containerStyle}>
                <div className="Home-search-container" style={style}>
                    <div style={{ textAlign: 'left' }}>{this.props.editing && 'Search'}</div>
                    <NewSearch
                        isMulti={true}
                        placeholder={LocalizedStrings.search}
                        isLoading={this.state.loading}
                        autoFocus={false}
                        onFocus={this.handleOnFocus}
                        onBlur={this.handleOnBlur}
                        onKeyDown={this.handleKeyPress}
                        disabled={this.props.disabled}
                        value={this.state.searchValue}
                        onSearchChange={this.handleOnChange}
                        onResultSelect={this.handleSelectedResult}
                        firstResults={this.state.autocompleteResultsLliure}
                        secondResults={this.state.autocompleteResultsTags}
                        thirdResults={this.state.autocompleteResultsAuthor}
                        theme={this.props.theme}
                    />
                </div>
                {this.props.editing && this.renderResults()}
            </div>
        );
    }
}
Search.propTypes = {
    notify: PropTypes.func,
    editing: PropTypes.bool.isRequired,
    onEditingChange: PropTypes.func.isRequired,
    searchStyle: PropTypes.object.isRequired,
    onResultSelected: PropTypes.func.isRequired,
    // exclusions: PropTypes.array,
    classes: PropTypes.object.isRequired,
    // resetSearch: PropTypes.func,
    disabled: PropTypes.bool,
    theme: PropTypes.string.isRequired,
    shareContext: PropTypes.bool,
    containerStyle: PropTypes.object,
};

export default withStyles(styles)(Search);
export { ImageIcon, ContentIcon, CollectionIcon, MeetingsIcon, VideoIcon, FileIcon, CategoryIcon, MetadocumentIcon, ExternalLinkIcon };
